export enum NewsCategoriesEnum {
  functions  = 6923128,
  suppliers  = 6923130,
  categories = 6923132
}
